import { api } from "../api/client"

export function supportsWebPush() {
  return "Notification" in window && "serviceWorker" in navigator && "PushManager" in window
}

export async function currentPushSubscription(): Promise<PushSubscription | null> {
  if (!supportsWebPush()) return null
  const registration = await navigator.serviceWorker.getRegistration()
  return registration ? registration.pushManager.getSubscription() : null
}

/**
 * Removes both sides of the device subscription. Server revocation is attempted
 * first while the access token still belongs to the user who is signing out.
 */
export async function cleanupPushSubscription(): Promise<void> {
  const subscription = await currentPushSubscription()
  if (!subscription) return
  try {
    await api.post<void>("/push/unsubscribe", { endpoint: subscription.endpoint })
  } finally {
    await subscription.unsubscribe().catch(() => false)
  }
}
